import { useEffect, useState } from 'react'
import Questionnaire from './Questionnaire'
import FitQuiz from './FitQuiz'
import AgentWorkflow from './AgentWorkflow'
import AgentWorkflowMobile from './AgentWorkflowMobile'
import AIPyramid from './AIPyramid'

export default function App() {
  const [open, setOpen] = useState(false)
  const [openFit, setOpenFit] = useState(false)
  const email = 'antoine@intellectus.fun'
  async function copyEmail() {
    try {
      await navigator.clipboard.writeText(email)
      // lightweight feedback
      console.log('Email copied')
    } catch {
      const ta = document.createElement('textarea')
      ta.value = email
      document.body.appendChild(ta)
      ta.select()
      document.execCommand('copy')
      document.body.removeChild(ta)
    }
    alert('Email copied to clipboard')
  }

  useEffect(() => {
    const check = () => {
      const u = new URL(window.location.href)
      if (u.hash === '#start' || u.searchParams.get('start') === '1') setOpen(true)
    }
    check()
    window.addEventListener('hashchange', check)
    return () => window.removeEventListener('hashchange', check)
  }, [])

  // Lock body scroll when modal is open (iOS friendly)
  useEffect(() => {
    const original = document.body.style.overflow
    document.body.style.overflow = open ? 'hidden' : original || ''
    return () => { document.body.style.overflow = original }
  }, [open])

  return (
    <div className="page">
      <header className="nav">
        <div className="brand">
          <span className="logo">∫</span>
          <span>Intellectus</span>
        </div>
        <nav className="site-nav" aria-label="Company">
          <a href="/products/">Products</a>
          <a href="/research/">Research</a>
          <a href="/company/">Company</a>
          <a href="/press/">Press</a>
        </nav>
        <div style={{ display: 'flex', gap: 8 }}>
          <a className="cta" href="#start" onClick={(e) => { e.preventDefault(); setOpen(true) }}>Start a project</a>
          <button className="cta" onClick={copyEmail} aria-label="Copy email">Copy email</button>
        </div>
      </header>

      <main className="hero">
        <div className="container">
          <h1>Agent Factory for Production</h1>
          <p className="tagline">
            We build and run AI agents deployed at scale — integrated with your
            tech stack and frictionless with your team.
          </p>
          <div className="actions">
            <a className="btn primary" href="#start" onClick={(e) => { e.preventDefault(); setOpen(true) }}>Start a project</a>
            <a className="btn ghost" href="#fit" onClick={(e) => { e.preventDefault(); setOpenFit(true) }}>Check fit</a>
          </div>
          <div className="email-chip" role="region" aria-label="Contact email">
            <code className="email">{email}</code>
            <button className="btn ghost small" onClick={copyEmail}>Copy</button>
          </div>
        </div>
      </main>

      <section aria-label="Agent workflow animation">
        <AgentWorkflow />
        <AgentWorkflowMobile />
      </section>

      <section className="outcomes" aria-label="Outcomes">
        <div className="card">
          <h4>Deploy agents</h4>
          <p>Production‑ready from day one.</p>
        </div>
        <div className="card">
          <h4>Integrate seamlessly</h4>
          <p>No friction with your team or tools.</p>
        </div>
        <div className="card">
          <h4>Scale value</h4>
          <p>From pilots to fleets, at pace.</p>
        </div>
      </section>

      <section className="products" aria-labelledby="products-heading">
        <div className="products__intro">
          <p className="eyebrow">Products in production</p>
          <h2 id="products-heading">Intellectus builds AI products that run real workflows.</h2>
          <p>
            Our public products prove the same operating model in different markets:
            production agents, domain memory, and human review where the work requires judgment.
          </p>
        </div>
          <div className="products__grid">
          <a className="product-card" href="https://duke.yt">
            <span>Duke</span>
            <strong>Procurement intelligence for public contracts</strong>
            <small>European tender monitoring, contract data, and bid/no-bid intelligence.</small>
          </a>
          <a className="product-card" href="https://clara.marketing">
            <span>Clara</span>
            <strong>Marketing intelligence for brand teams</strong>
            <small>Campaign structure, brand memory, and always-on execution support.</small>
          </a>
        </div>
        <div className="products__links" aria-label="More product context">
          <a href="/products/">See the Intellectus product portfolio</a>
          <a href="/research/">Read the operating model</a>
        </div>
      </section>

      <AIPyramid />

      <section className="features" aria-label="Value">
        <div>
          <h3>Factory</h3>
          <p>Design, spin‑up, and operate production agents.</p>
        </div>
        <div>
          <h3>Integration</h3>
          <p>Plug into your stack, data, and workflows.</p>
        </div>
        <div>
          <h3>Scale</h3>
          <p>From one agent to fleet, safely.</p>
        </div>
      </section>

      <footer className="footer">
        <span>© {new Date().getFullYear()} Intellectus</span>
        <nav aria-label="Footer">
          <a href="/products/">Products</a>
          <a href="/company/">Company</a>
          <a href="/research/">Research</a>
          <a href="/press/">Press</a>
        </nav>
      </footer>

      {open && <Questionnaire onClose={() => { setOpen(false); if (window.location.hash === '#start') history.replaceState(null, '', window.location.pathname) }} />}
      {openFit && <FitQuiz onClose={() => setOpenFit(false)} onStartProject={() => { setOpenFit(false); setOpen(true) }} />}

      <div className="sticky-cta" aria-hidden={open || openFit}>
        <a className="btn ghost" href="#fit" onClick={(e) => { e.preventDefault(); setOpenFit(true) }}>Check fit</a>
        <a className="btn primary" href="#start" onClick={(e) => { e.preventDefault(); setOpen(true) }}>Start a project</a>
      </div>
    </div>
  )
}
